import { render } from "./CookieConsent.vue?vue&type=template&id=7fdce81d"
import script from "./CookieConsent.vue?vue&type=script&lang=js"
export * from "./CookieConsent.vue?vue&type=script&lang=js"

import "@/assets/scss/_cookie-consent.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__